/**
 * Leaf context module for the chronology Build-with-Arc lane.
 *
 * BuildPlanCard (rendered via ChatMessage.TOOL_CARDS) needs the lane's run
 * handler; putting the context in its own leaf module keeps the import chain
 * acyclic (ChatMessage → BuildPlanCard → here; ChronologyBuildLane → here) —
 * same convention as chronologyRefineContext (circular-imports lesson).
 *
 * Value shape: { run(plan, planKey) → Promise<report>, reports:
 * {[planKey]: report}, addEvents(events, key) → Promise<report>,
 * addedEvents: {[key]: report}, busy, chronologyId } — null outside a build
 * lane (cards then render read-only). `run` drives the plan card;
 * `addEvents` drives the source-drafted EventDraftCard.
 */
import { createContext, useContext } from 'react';

export const ChronologyBuildContext = createContext(null);

export function useChronologyBuild() {
  return useContext(ChronologyBuildContext);
}
